import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d53a6060"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-labelledby"]
const _hoisted_2 = { class: "dashboard-news__header" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "dashboard-news__subtitle" }
const _hoisted_5 = { class: "dashboard-news__grid" }
const _hoisted_6 = { class: "dashboard-news-card__top" }
const _hoisted_7 = ["datetime"]
const _hoisted_8 = { class: "dashboard-news-card__title" }
const _hoisted_9 = { class: "dashboard-news-card__summary" }
const _hoisted_10 = ["aria-label", "onClick"]
const _hoisted_11 = {
  key: 0,
  class: "dashboard-news-details"
}
const _hoisted_12 = { class: "dashboard-news-details__meta" }
const _hoisted_13 = ["datetime"]
const _hoisted_14 = { class: "dashboard-news-details__intro" }
const _hoisted_15 = { class: "dashboard-news-details__source" }
const _hoisted_16 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!
  const _component_ExternalLinkIcon = _resolveComponent("ExternalLinkIcon")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", {
      class: "dashboard-news",
      "aria-labelledby": _ctx.sectionTitleId
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("h2", {
            id: _ctx.sectionTitleId,
            class: "dashboard-news__title"
          }, _toDisplayString(_ctx.$t("dashboard.news.title")), 9, _hoisted_3),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("dashboard.news.subtitle")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newsItems, (item) => {
          return (_openBlock(), _createElementBlock("article", {
            key: item.id,
            class: "dashboard-news-card"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", {
                class: _normalizeClass(["dashboard-news-card__icon", `dashboard-news-card__icon--${item.variant}`])
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { "aria-hidden": "true" }))
              ], 2),
              _createElementVNode("time", {
                class: "dashboard-news-card__date",
                datetime: item.publishedAt
              }, _toDisplayString(_ctx.formatNewsDate(item.publishedAt)), 9, _hoisted_7)
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["dashboard-news-card__category", `dashboard-news-card__category--${item.variant}`])
            }, _toDisplayString(_ctx.$t(item.categoryKey)), 3),
            _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t(item.titleKey)), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t(item.summaryKey)), 1),
            _createElementVNode("button", {
              type: "button",
              class: "dashboard-news-card__link",
              "aria-label": `${_ctx.$t('dashboard.news.readMore')}: ${_ctx.$t(item.titleKey)}`,
              onClick: ($event: any) => (_ctx.openDetails(item))
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t("dashboard.news.readMore")) + " ", 1),
              _createVNode(_component_ArrowRightIcon, { "aria-hidden": "true" })
            ], 8, _hoisted_10)
          ]))
        }), 128))
      ])
    ], 8, _hoisted_1),
    _createVNode(_component_Modal, {
      show: _ctx.selectedItem !== null,
      title: _ctx.selectedItem ? _ctx.$t(_ctx.selectedItem.titleKey) : '',
      onClose: _ctx.closeDetails
    }, {
      default: _withCtx(() => [
        (_ctx.selectedItem)
          ? (_openBlock(), _createElementBlock("article", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", {
                  class: _normalizeClass(["dashboard-news-card__category", `dashboard-news-card__category--${_ctx.selectedItem.variant}`])
                }, _toDisplayString(_ctx.$t(_ctx.selectedItem.categoryKey)), 3),
                _createElementVNode("time", {
                  datetime: _ctx.selectedItem.publishedAt
                }, _toDisplayString(_ctx.formatNewsDate(_ctx.selectedItem.publishedAt)), 9, _hoisted_13)
              ]),
              _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t(_ctx.selectedItem.detailsIntroKey)), 1),
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.selectedItem.orderedDetails ? 'ol' : 'ul'), {
                class: _normalizeClass(["dashboard-news-details__list", {
          'dashboard-news-details__list--ordered': _ctx.selectedItem.orderedDetails,
        }])
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedItem.detailKeys, (key) => {
                    return (_openBlock(), _createElementBlock("li", { key: key }, _toDisplayString(_ctx.$t(key)), 1))
                  }), 128))
                ]),
                _: 1
              }, 8, ["class"])),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("a", {
                  href: _ctx.sourceUrl(_ctx.selectedItem),
                  target: "_blank",
                  rel: "noopener noreferrer",
                  referrerpolicy: "no-referrer"
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t("dashboard.news.officialSource")) + " ", 1),
                  _createVNode(_component_ExternalLinkIcon, { "aria-hidden": "true" })
                ], 8, _hoisted_16),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("dashboard.news.sourceNotice")), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show", "title", "onClose"])
  ], 64))
}